/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Wizard_SubtitleInputs */

const cs_import_wizard_subtitle = /** @type {(inputs: Import_Wizard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migrujte nemovitosti a makléře z feedu nebo souboru. Nejprve náhled celého plánu, pak potvrzení.`)
};

const en_import_wizard_subtitle = /** @type {(inputs: Import_Wizard_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Migrate listings and brokers from a feed or file. Preview the full plan, then commit.`)
};

/**
* | output |
* | --- |
* | "Migrate listings and brokers from a feed or file. Preview the full plan, then commit." |
*
* @param {Import_Wizard_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_wizard_subtitle = /** @type {((inputs?: Import_Wizard_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Wizard_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_wizard_subtitle(inputs)
	return cs_import_wizard_subtitle(inputs)
});